<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4 4V14.5C4 15.3284 4.67157 16 5.5 16H16" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.125 11.875H8.1325M8.5 11.875C8.5 12.0821 8.33211 12.25 8.125 12.25C7.91789 12.25 7.75 12.0821 7.75 11.875C7.75 11.6679 7.91789 11.5 8.125 11.5C8.33211 11.5 8.5 11.6679 8.5 11.875Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.625 7.375H9.6325M10 7.375C10 7.58211 9.83208 7.75 9.625 7.75C9.41792 7.75 9.25 7.58211 9.25 7.375C9.25 7.16789 9.41792 7 9.625 7C9.83208 7 10 7.16789 10 7.375Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.375 9.625H13.3825M13.75 9.625C13.75 9.83208 13.5821 10 13.375 10C13.1679 10 13 9.83208 13 9.625C13 9.41792 13.1679 9.25 13.375 9.25C13.5821 9.25 13.75 9.41792 13.75 9.625Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.875 5.125H14.8825M15.25 5.125C15.25 5.33211 15.0821 5.5 14.875 5.5C14.6679 5.5 14.5 5.33211 14.5 5.125C14.5 4.91789 14.6679 4.75 14.875 4.75C15.0821 4.75 15.25 4.91789 15.25 5.125Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ScatterGraphIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>